import { React, useState }  from "react";
import "./Home.css";

const Home = () => {
    const [showHire, setShowHire] = useState(true);
    const [showLaunch, setShowLaunch] = useState('');
    const [showScale, setShowScale] = useState('');

    const handleHire = () => {
        setShowHire(true)
        setShowScale(false)
        setShowLaunch(false)
    }

    const handleLaunch = () => {
        setShowLaunch(true)
        setShowHire(false)
        setShowScale(false)
    }

    const handleScale = () => {
        setShowLaunch(false)
        setShowHire(false)
        setShowScale(true)
    }

    return(
        <div>
            <div className='hero-banner'>
                <h1>Careers at V3</h1>
                <h2 className='fade-in-text-1'>
                    To those who make their own way,
                    <br />
                    we want you.
                </h2>
                <img className='img-develop fade-in-text-2' src={require('../../static/images/develop-succeed-grow.png')} alt="V3 Culture" />
            </div>

            <div className='what-we-do'>
                
                <div>
                    <h1>What We Do</h1>

                    <div id="carouselExampleCaptions" className="carousel slide">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="3" aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="4" aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="5" aria-label="Slide 6"></button>
                        </div>
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <h5>Sales</h5>
                                <img className='img-departments' src={require('../../static/images/Sales.png')} alt="Sales Meeting" />
                                <p>Develop your own basic skills, improve yourself on more advanced skills, help others to develop their own skills, and lead your own team.</p>
                            </div>
                            <div className="carousel-item">
                                <h5>Installation</h5>
                                <img className='img-departments' src={require('../../static/images/Installation.png')} alt="Installation" />
                                <p>All installations are completed in-house, or in rare cases by our highly qualified network of subcontractors. This allows us to guarantee the quality assurance you would expect from the best local solar company.</p>
                            </div>
                            <div className="carousel-item">
                                <h5>Marketing</h5>
                                <img className='img-departments' src={require('../../static/images/Marketing.png')} alt="Marketing" />
                                <p>Our marketing team is intimately familiar with content creation and social marketing for Fortune 500 companies. This helps provide the right context and branding to the customers you work with on a daily basis.</p>
                            </div>
                            <div className="carousel-item">
                                <h5>Office</h5>
                                <img className='img-departments' src={require('../../static/images/Office.png')} alt="Office" />
                                <p>We have a team of superstars in each office that supports the install, design, and sales department. Most importantly, they support our happy customers! We provide on-site training and development to ensure you’re able to provide the best service possible.</p>
                            </div>
                            <div className="carousel-item">
                                <h5>Financing</h5>
                                <img className='img-departments' src={require('../../static/images/Financing.png')} alt="Financing" />
                                <p>As of the fourth quarter of 2017, V3 Electric is offering in-house financing to its customers. This means we are strengthening our company, as well as eliminating the middle man for our customers. They will get the same customer experience they are used to throughout the sale and installation process for the next 20 years!</p>
                            </div>
                            <div className="carousel-item">
                                <h5>Monitoring</h5>
                                <img className='img-departments' src={require('../../static/images/Monitoring.png')} alt="Monitoring" />
                                <p>We offer remote cellular monitoring. This means customers don’t need to worry about power failures or lack of internet to allow us to monitor their systems to guarantee peak performance.</p>
                            </div>
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>
                
            </div>

            <div className='how-we-do-it'>
                <h1>How We Do It</h1>

                <div className='how-we-do-it-content'>
                    <div className={showHire ? '' : 'd-none'}>
                        <h2>Hire Smart</h2>
                        <p>One of the most important things a company can get right is the quality of people they hire. If everyone is working feverishly towards the same goal, you are virtually guaranteed to win. “The secret of our success is that we have gone to exceptional lengths to hire some of the best people in the industry."</p>
                    </div>
                    <div className={showLaunch ? '' : 'd-none'}>
                        <h2>Launch & Grow</h2>
                        <p>Growth is a by-product of everyone working together to achieve greatness. You must look at success as a journey, not as a destination. "Growth is never by mere chance; it is the result of forces working together."</p>
                    </div>
                    <div className={showScale ? '' : 'd-none'}>
                        <h2>Systems of Scale</h2>
                        <p>Scaling a business is an art and a science. If you give your people the tools to succeed, enable them to make the right decisions, and trust them to maintain the discipline needed, you have a recipe for achieving great things. “Goals without routines are wishes; routines without goals are aimless. The most successful business leaders have a clear vision and the discipline to make it a reality.”</p>
                    </div>

                    <div className='how-we-do-images'>
                        <div className={showHire ? 'activeImg' : ''}>
                            <img className='img-how-we-do-it' src={require('../../static/images/hireSmartIcon.png')} alt="Hire Smart" onClick={handleHire} />
                        </div>
                        <div className={showLaunch ? 'activeImg' : ''}>
                            <img className='img-how-we-do-it' src={require('../../static/images/launchGrowIcon.png')} alt="Launch Grow" onClick={handleLaunch} />
                        </div>
                        <div className={showScale ? 'activeImg' : ''}>
                            <img className='img-how-we-do-it' src={require('../../static/images/system_scale_icon.png')} alt="System Scale" onClick={handleScale} />
                        </div>
                    </div>
                </div>
            </div>

            <div className='about-us'>
                <div className='container'>
                    <h1 className='pb-3'>What Does V3 Mean?</h1>
                    <p className='pb-4'>V3 comes from the three core values of the company.<br/> In short, it means driven for a cause.</p>

                    <div className='row'>
                        <div className='col'>
                            <h2>VIM</h2>
                            <h3 className='pb-3'>Energy and Drive</h3>
                            <p>At V3 we have a young, hungry spirit to work hard and do what is right. We are disrupting the energy industry, and that gives us purpose.</p>
                        </div>
                        <div className='col'>
                            <h2>VOLITION</h2>
                            <h3 className='pb-3'>Freedom of Choice</h3>
                            <p>We believe that more options gives us freedom. You should have a choice in how you buy your energy. Our customers enjoy that freedom.</p>
                        </div>
                        <div className='col'>
                            <h2>VITA</h2>
                            <h3 className='pb-3'>Way of Life</h3>
                            <p>This is not just a job for us. It bleeds into everything we do, on and off the clock. At V3, our employees embody our cause and purpose. It’s what drives us forward. It’s our way of life.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;